export default {"src":"/_next/static/media/public-match.40449e91.svg","height":12,"width":15,"blurWidth":0,"blurHeight":0};